import axios from 'axios';
import { polusBaseUrl, POST } from '../../../utils/axios-interceptor';
import { BucketType } from '../../../modules/Dashboard/DashboardModules/Financials/components/FinancialsFromBankingV2/types';

export function fetchBankEntityRationaleService() {
    return axios({
        baseURL: polusBaseUrl,
        url: '/data/bankEntityRationale',
        method: POST,
        data: {},
    });
}

export function fetchBankStatementCashflowBucketsService(window?: { startDate?: string; endDate?: string; accountIds?: string[] }) {
    const hasWindow = !!window?.startDate && !!window?.endDate;
    return axios({
        baseURL: polusBaseUrl,
        url: '/data/bankStatementCashflowBuckets',
        method: POST,
        data: {
            ...(hasWindow ? { startDate: window!.startDate, endDate: window!.endDate } : {}),
            ...(window?.accountIds?.length ? { accountIds: window!.accountIds } : {}),
        },
    });
}

export interface BucketPayload {
    bucketType: BucketType;
    bucketKey: string | null;
    classificationId?: number | null;
    startDate?: string;
    endDate?: string;
    accountIds?: string[];
}

export function fetchBankTransactionsByBucketService(bucket: BucketPayload) {
    return axios({
        baseURL: polusBaseUrl,
        url: '/data/bankTransactionsByBucket',
        method: POST,
        data: bucket,
    });
}
